import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';

import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext';
import { Create_page } from "./create_page";
import { Randomcode } from "../components_root/rendom_code";
import Cookies from "js-cookie";
import { RiPagesLine } from "react-icons/ri";
import { HiOutlineDuplicate } from "react-icons/hi";
import { MdAdd, MdDeleteForever, MdEdit, MdSave, MdSaveAlt } from "react-icons/md";
 
export const seo = {
    title: "Aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover Aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "Aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Website_settings() {
    const [text, setText] = useState("");
     const [companyuid, setcompanyuid] = useState(Cookies.get("website_company_uid"));
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size">
                    <div className='post-container'>
                        <div className='post_div'>
                            <br/>
                            <div className="text-h1 bold m-top">Website settings</div>
                            
                               <div className="m-top">
                               Companyuid: {companyuid}
                            </div>
                            <div className="m-top">
                                <input className="p-1 fcap" maxLength={30} placeholder="Enter new page name" />
                            </div>
                                <div className="m-top">
                                <input className="p-1 " maxLength={200} placeholder="Enter descrption" />
                            </div>
                                 <div className="m-top">
                                <textarea className="p-1" maxLength={200} placeholder="Enter keywords" />
                            </div>
                            <br/>
                            <div className="button-ui p-22 text-h2 cursor m-top">Save & continue</div>
                        </div>
                        <div className="post_updates">

                        </div>

                    </div>

                </div>
            </div>



        </div>
    );
}
